import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'broker-opportunity-submission-details-dialog',
  templateUrl: './opportunity-submission-details-dialog.component.html',
  styleUrls: ['./opportunity-submission-details-dialog.component.scss']
})
export class OpportunitySubmissionDetailsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
